export const riskAssessmentSteps = {
    HAZARDS: 0,
    PEOPLE: 1,
    EVALUATE: 2,
    RECORD: 3,
  };